/* ===========================================================================
 * WHERE THE WORKSITE SHEET LIVES IN THE ADDRESS BAR.
 *
 * Create and edit are a dialog over the worksites list now, and the dialog is
 * driven by the query string — `?new=1` or `?edit=<id>` — so it can be linked,
 * bookmarked and reloaded like the pages it replaced. The retired
 * `/worksites/new` and `/worksites/:id/edit` redirect here (see
 * `WorksiteDialogRedirect`); in-app links use these helpers directly, because a
 * link at a redirect is a guarded defect (`navigationWiring.test.ts`).
 * ======================================================================== */

/** Query key that opens the create sheet. */
export const NEW_PARAM = 'new';
/** Query key whose value is the id of the site the edit sheet opens. */
export const EDIT_PARAM = 'edit';

/** The worksites list with the create sheet open. */
export const NEW_WORKSITE_HREF = `/worksites?${NEW_PARAM}=1`;

/** The worksites list with the edit sheet open on one site. */
export function editWorksiteHref(id: string): string {
  return `/worksites?${EDIT_PARAM}=${encodeURIComponent(id)}`;
}

/**
 * A camp's worksite page, on its Residents tab — where the retired
 * `/worksites/:id/camp-occupancy` lands (`CampOccupancyRedirect`), and where
 * in-app links to "this camp's occupancy" go directly.
 */
export function campResidentsHref(id: string): string {
  return `/worksites/${encodeURIComponent(id)}?tab=residents`;
}
